module.exports = __webpack_public_path__ + "static/media/ESTRATEGIA_CONOCIMIENTO.45ed36f8.png";